<template>
  <div class="list-area">
     <!-- <div class="filter-area">
        <Input v-model="filterName" placeholder="请输入..." clearable style="width:200px"></Input>
        <Button type="success" @click="searchEvent()" class="ml10">搜索</Button>
      </div> -->
    <div class="edit-area mt10" ref="table">
      <vxe-table ref="chkTable" border resizable show-overflow show-header-overflow :data="list" :height="tabHeight" :row-config="{isHover: true}">
        <vxe-column type="seq" width="60" ></vxe-column>
        <vxe-column field="isOwner" title="拥有者" width="70" header-align="center">
          <template #default="{ row }">
            <div :style="{color: row.isOwner ? 'blue' : 'green'}">{{row.isOwner ? '是' : '否'}}</div>
          </template>
        </vxe-column>
        <vxe-column field="stats" title="状态" width="70" header-align="center">
          <template #default="{ row }">
            {{getUserState(row)}}
          </template>
        </vxe-column>
        <vxe-column field="code" title="登录名" width="120" header-align="center">
          <template #default="{ row }">
            {{row.code}}
          </template>
        </vxe-column>
        <vxe-column field="name" title="姓名" width="100" header-align="center">
          <template #default="{ row }">
            {{row.name}}
          </template>
        </vxe-column>
        <vxe-column field="mobile" title="手机号" width="130" header-align="center">
          <template #default="{ row }">
            {{row.mobile}}
          </template>
        </vxe-column>
        <vxe-column field="needExpire" title="过期时间" width="100" header-align="center">
          <template #default="{ row }">
            {{row.needExpire ? new Date(row.expire).format('yyyy-MM-dd') : '永久'}}
          </template>
        </vxe-column>
        <vxe-column field="roleName" title="角色权限" header-align="center">
          <template #default="{ row }">
            {{row.roleNames.join(',')}}
          </template>
        </vxe-column>
        <vxe-column field="groupName" title="分区权限" header-align="center">
          <template #default="{ row }">
            {{row.groupNames.join(',')}}
          </template>
        </vxe-column>
        <vxe-column width="300" title="操作" fixed="right">
          <template #header>
            <Button v-if="funCodes('pua')" size="small" type="primary" style="margin-right: 5px" @click="handleAdd">创建或邀请用户</Button>
            <Button v-if="funCodes('puv')" size="small" type="primary" style="margin-right: 5px" @click="getList">刷新</Button>
          </template>
          <template #default="{ row }">
            <Button v-if="row.locked && funCodes('sue1')" size="small" type="success" style="margin-right: 5px" @click="handleLocked(row)">解锁</Button>
            <Button v-if="row.id != user.id && funCodes('sue1')" size="small" :type="row.active ? 'warning' : 'success'" style="margin-right: 5px" @click="handleEnable(row)">{{row.active ? '禁用' : '启用'}}</Button>
            <Button v-if="!row.isOwner && row.id != user.id && user.id == ownerId && funCodes('pue')" size="small" type="success" style="margin-right: 5px" @click="handleOwner(row)">移交项目权属</Button>
            <Button v-if="funCodes('pue')" size="small" type="primary" style="margin-right: 5px" @click="handleEdit(row)">设置权限</Button>
            <Button v-if="!row.isOwner && row.id != user.id && funCodes('pud')" size="small" type="error" @click="handleDelete(row)">移出项目</Button>
          </template>
        </vxe-column>
      </vxe-table>
    </div>
    <ModalUserEdit v-model="showEditModal" :item="editItem" @saved="itemSaved" />
    <ModalUserCreateOrInvit v-model="showUserModal" @saved="itemSaved" />
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import ModalUserEdit from './ModalRoleAndGroup'
import ModalUserCreateOrInvit from './ModalUserCreateOrInvit'
export default {
  name: 'ModalUserList',
  components: {
    ModalUserEdit,
    ModalUserCreateOrInvit,
  },
  model: {
    prop: 'value',
    event: 'showChanged'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default() { return {}; }
    },
  },
  data() {
    return {
      tabHeight: 600,
      showModal: this.value,
      editItem: {},
      showEditModal: false,
      showUserModal: false,
      loading: false,
      isAdd: false,
      listData: [],
      list: [],
      filterName: ''
    }
  },
  computed: {
    ...mapGetters('auth', ['funCodes']),
    ...mapState('auth', ['user']),
    ownerId: function(){
      let us = this.list.filter(p => p.isOwner);
      if(us.length > 0)return us[0].id;
      return 0;
    },
  },
  watch: {
    windowOnResize(){
      this.setTableHeight();
    },
    value(newVal) {
      this.showModal = newVal;
    },
    showModal(val) {
      this.$emit('showChanged', val);
    },
  },
  mounted: function () {
    this.getList();
    setTimeout(this.setTableHeight, 100);
  },
  methods: {
    setTableHeight: function(){
      this.tabHeight = this.$refs.table.clientHeight - 4;
    },
    handleOwner: function(params){
      this.$Modal.confirm({
        title: "提示",
        content: `确定要设置用户[${params.name}]为当前项目的拥有者吗?`,
        onOk: async () => {
          this.$axios.post(`sys/auth/SetOwner`, { userId: params.id }).then(res => {
            if (res.code == 0) {
              this.getList();
            }
          });
        }
      });
    },
    getUserState: function (params) {
      if (!params.active) {
        return '已停用';
      }
      if(params.locked){
        return '已锁定';
      }
      if (params.needExpire) {
        let expire = new Date(params.expire);
        expire.setDate(expire.getDate() + 1);
        if (new Date().getTime() > expire.getTime()) {
          return '已过期';
        }
      }
      return '正常';
    },
    handleAdd: function () {
      this.showUserModal = true;
    },
    handleEdit: function (params) {
      this.editItem = { user: params };
      this.showEditModal = true;
    },
    handleEnable: function (params) {
      this.$Modal.confirm({
        title: "提示",
        content: `确定要${params.active ? '禁用' : '启用'}用户[${params.name}]吗?`,
        onOk: async () => {
          this.$axios.post(`sys/auth/EnableUserOld`, { id: params.id, active: !params.active }).then(res => {
            if (res.code == 0) {
              this.getList();
            }
          });
        }
      });
    },
    handleLocked: function (params) {
      this.$Modal.confirm({
        title: "提示",
        content: `确定要解锁用户[${params.name}]吗?`,
        onOk: async () => {
          this.$axios.post(`sys/auth/UnlockUserOld`, { id: params.id }).then(res => {
            if (res.code == 0) {
              this.getList();
            }
          });
        }
      });
    },
    handleDelete: function (params) {
      this.$Modal.confirm({
        title: "提示",
        content: `确定要将用户[${params.code}]移出该项目吗?`,
        onOk: async () => {
          this.$axios.post(`sys/auth/RemoveUserCust`, { userId: params.id }).then(res => {
            if (res.code == 0) {
              this.getList();
            }
          });
        }
      });
    },
    getList: function () {
      this.$axios.post(`sys/auth/QueryCustUsersOld`, { }).then(res => {
        if (res.code == 0) {
          this.$set(this, 'list', res.data);
        }
      });
    },
    itemSaved: function () {
      this.getList();
    },
    cancel() {
      this.showModal = false;
    },
  }
}
</script>
<style scoped>
.list-area{
  /* border: solid 1px blue; */
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.filter-area{
  height: 30px;
  flex: none;
}
.form-item-group {
  border: solid 1px rgba(129, 124, 124, 0.377);
  border-radius: 12px;
  margin-bottom: 15px;
}
.group-header {
  /* border: solid 1px blue; */
  background-color: rgba(221, 216, 216, 0.808);
  margin-bottom: 15px;
  height: 35px;
  border-radius: 12px 12px 0 0;
  line-height: 35px;
  font-weight: bold;
  padding: 0 10px;
}
.edit-area {
  /* border: solid 1px blue; */
  width: 100%;
  height: 600px;
  flex: auto;
  /* display: flex; */
}
.form-area {
  width: 410px;
  flex: none;
}
.fun-area {
  width: 400px;
  flex: auto;
  margin-left: 20px;
  border: solid 1px rgba(216, 199, 199, 0.438);
  border-radius: 6px;
  overflow: auto;
  position: relative;
}
.chk-all {
  position: absolute;
  top: 10px;
  right: 10px;
}
.logo-upload {
  width: 410px;
  height: 114px;
  border: solid 1px gray;
  cursor: pointer;
}
.logo-upload input {
  visibility: hidden;
}
.logo-upload img {
  width: 410px;
  height: 114px;
}
.fun-list {
  display: flex;
  /* list-style: none; */
  flex-direction: column;
  margin: 8px 15px;
}
.chk-list {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
}
li {
  margin: 0 5px;
}
</style>